import { useEffect, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import {
  resetPassword,
  RootState,
  setOtpSuccess,
  showToast,
  useAppDispatch,
  useAppSelector,
  HOME_ROUTE,
  REGISTER,
  getOtpButtonVisibility,
} from "@hypexone/uicore";
import { connect } from "react-redux";
import Button from "../../components/shared/Button/Button";
import HeaderButtonComponent from "../../components/header/HeaderButtonComponent";
import RightArrowIcon from "../../../assets/icons/header-icons/right-arrow-white.svg";
import { getEnvVariable } from "../../../constants/brandConfig";
import { domain } from "../../../constants/Branding";
import { SVLS_API_CLIENT } from "../../../App.utils";

const ForgotPassword = (props) => {
  const { otpSuccess, showToast } = props;
  const [method, setMethod] = useState("Username");
  const [username, setUsername] = useState("");
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [countryCode, setCountryCode] = useState("+91");
  const navigate = useNavigate();
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [otpTimer, setOtpTimer] = useState<number>();
  const { otpSent } = useAppSelector((state) => state.auth);
  const { langData } = useAppSelector((state) => state.cms);
  const { domainConfig } = useAppSelector((state) => state.common);
  const handleOtpTimer = (time) => {
    if (time >= 0) {
      setOtpTimer(time);
      setTimeout(() => {
        handleOtpTimer(time - 1);
      }, 1000);
    } else {
      setTimeout(() => {
        setOtpTimer(undefined);
      }, 1000);
    }
  };
  useEffect(()=>{
    if(otpSuccess){
      handleOtpTimer(60);
    }
  },[otpSuccess])
  
  useEffect(()=>{
    if(otpSent){
      handleOtpTimer(60);
    }
  },[otpSent])

  const dispatch = useAppDispatch();

  const showConfirmPasswordClickHandler = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const showPasswordClickHandler = () => {
    setShowPassword(!showPassword);
  };

  const handleMethodChange = (newMethod) => {
    setMethod(newMethod);
    setUsername("");
    setMobile("");
  };

  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
  };

  const handleMobileChange = (event) => {
    setMobile(event.target.value);
  };

  const handleCountryCodeChange = (event) => {
    setCountryCode(event.target.value);
  };

  const handlesendotp = async (isWhatsapp = false) => {
    try {
      const userIdentifier =
        method === "Username" ? username.toLowerCase() : "91" + mobile;
      const queryParam =
        method === "Username"
          ? isWhatsapp
            ? "?isWhatsapp=true"
            : ""
          : `?userIdentifierType=PHONE_NUMBER${
              isWhatsapp ? "&isWhatsapp=true" : ""
            }`;
      const url = `/account/v2/users/${encodeURIComponent(
        userIdentifier
      )}/:sendResetPasswordOtp${queryParam}`;
      const response = await SVLS_API_CLIENT.post(url);
      if (response.status === 204) {
        dispatch(
          showToast({
            message: "OTP sent successfully.",
            type: "success",
          })
        );
        dispatch(setOtpSuccess(true));
        handleOtpTimer(60);
      } else {
        dispatch(
          showToast({
            message: "Unable to send OTP.",
            type: "error",
          })
        );
      }
    } catch (err: any) {
      dispatch(
        showToast({
          message:
            err?.response?.data?.message ||
            langData?.["something_went_wrong"] ||
            "Unable to send OTP.",
          type: "error",
        })
      );
    }
  };

  const { showSmsOtpButton, showWhatsappOtpButton, showGenericOtpButton } =
    getOtpButtonVisibility(domainConfig);
  const showOtpButtons =
    showSmsOtpButton || showWhatsappOtpButton || showGenericOtpButton;

  const redirectToSignUp = () => {
    navigate(REGISTER);
  };

  const handleResetPassword = () => {
    if (newPassword !== confirmPassword) {
      showToast({
        message: "Passwords didn't match",
        type: "error",
      });
      return;
    } else {
      dispatch(resetPassword({
        username: username,
        phoneNumber: '91' + mobile,
        resetPassword: newPassword,
        otp: otp,
        option: method,
      }));
    }
  };


  const handleBackPress = () => {
    navigate(-1);
  };

  return (
    <div className="relative flex min-h-screen w-full flex-col bg-gradient-to-r from-primary via-secondary to-teritary">
      <div className="pointer-events-none absolute inset-0 bg-black/20" />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/25" />

      <div className="relative z-10 flex min-h-screen w-full flex-col p-4">
        <div>
          <HeaderButtonComponent
            leftIcon={{
              src: RightArrowIcon,
              alt: "right-arrow",
              customClassName: "h-2.5 w-2.5 scale-x-[-1]",
            }}
            onClick={handleBackPress}
            buttonText={langData?.["back"]}
          />
        </div>

        <div className="flex flex-1 flex-col items-center justify-center py-6">
          <img
            src={getEnvVariable(domain, "logo")}
            alt="logo"
            className="h-auto max-h-[50px] w-auto cursor-pointer"
            onClick={() => navigate(HOME_ROUTE)}
          />

          <div className="w-full max-w-sm md:max-w-md rounded-xl border border-white/15 bg-black/25 p-5 md:p-6 shadow-[0_12px_40px_rgba(0,0,0,0.25)] backdrop-blur-sm">
          <h2 className="text-2xl text-center font-bold mb-4 text-white">
          {langData?.['forgot_password']}
          </h2>
          {!otpSuccess ? (
            <>
              <p className="mb-6 text-white">
              {langData?.['otp_send_msg']}
              </p>
              <div className="mb-4 flex">
                <Button
                  className={`flex-1 py-2 ${method === "Username"
                      ? "bg-black1 text-blue32"
                      : "bg-gray-200"
                    }`}
                  onClick={() => handleMethodChange("Username")}
                >
                  {langData?.['username']}
                </Button>
                <Button
                  className={`flex-1 py-2 ${method === "mobile"
                      ? "bg-black1 text-blue32"
                      : "bg-gray-200"
                    }`}
                  onClick={() => handleMethodChange("mobile")}
                >
                  Mobile Number
                </Button>
              </div>
              <div>
                {method === "Username" ? (
                  <div className="mb-4">
                    <label className="block text-white">{langData?.['username']}</label>
                    <input
                      type="text"
                      className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      value={username}
                      onChange={(e) => handleUsernameChange(e)}
                      placeholder={langData?.['enter_username_txt']}
                    />
                  </div>
                ) : (
                  <div className="mb-4">
                    <label className="block text-gray-700">{langData?.['mobile_number']}</label>
                    <div className="flex">
                      <select
                        className="mt-1 block w-20 px-3 py-2 bg-white border border-gray-300 rounded-l-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        value={countryCode}
                        onChange={(e) => handleCountryCodeChange(e)}
                      >
                        <option value="+91">+91</option>
                      </select>
                      <input
                        type="text"
                        className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-r-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        value={mobile}
                        onChange={(e) => handleMobileChange(e)}
                        placeholder={langData?.['enter_mobile_no']}
                      />
                    </div>
                  </div>
                )}
                {otpTimer !== undefined && otpTimer !== null && otpTimer >= 0 ? (
                  <Button
                    className="w-full bg-neutral-400 text-white py-2 rounded-md cursor-not-allowed"
                    disabled
                  >
                    {`Resend in ${otpTimer} sec`}
                  </Button>
                ) : showOtpButtons ? (
                  <div className="flex gap-2">
                    {(showSmsOtpButton || showGenericOtpButton) && (
                      <Button
                        className={`flex-1 bg-black1 text-blue32 py-2 rounded-md hover:bg-black focus:outline-none focus:text-white disabled:bg-neutral-400 disabled:cursor-not-allowed ${!showWhatsappOtpButton ? "w-full" : ""}`}
                        disabled={
                          method === "mobile"
                            ? mobile.length < 10
                            : username.length === 0
                        }
                        onClick={() => handlesendotp(false)}
                      >
                        {showGenericOtpButton
                          ? langData?.["send_otp"] ?? "Send OTP"
                          : langData?.["get_otp"] ?? "SMS OTP"}
                      </Button>
                    )}
                    {showWhatsappOtpButton && (
                      <Button
                        className={`flex-1 bg-teal-600 hover:bg-teal-700 text-white py-2 rounded-md disabled:bg-neutral-400 disabled:cursor-not-allowed ${!showSmsOtpButton && !showGenericOtpButton ? "w-full" : ""}`}
                        disabled={
                          method === "mobile"
                            ? mobile.length < 10
                            : username.length === 0
                        }
                        onClick={() => handlesendotp(true)}
                      >
                        {langData?.["get_otp_whatsapp"] ?? "WhatsApp OTP"}
                      </Button>
                    )}
                  </div>
                ) : null}
              </div>
            </>
          ) : (
            <>
              <div className="mb-4">
                <label className="block text-gray-700">{langData?.['otp']}</label>
                <input
                  type="number"
                  className="appearance-none mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-700 focus:border-blue-800 sm:text-sm"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  placeholder={langData?.['enter_otp_txt']}
                />
              </div>
              <div className="mt-5">
                <label
                  htmlFor="password"
                  className="self-start text-neutral-500"
                >
                  {langData?.['password']}
                </label>
                <div className="flex gap-5 justify-between px-3.5 py-3 mt-3 bg-white rounded-lg border border-solid border-neutral-200 placeholder:text-neutral-500 text-opacity-60">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    className="w-full bg-transparent border-none focus:outline-none"
                    placeholder={langData?.['enter_your_password']}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                  <div
                    className="cursor-pointer text-neutral-500"
                    onClick={() => showPasswordClickHandler()}
                  >
                    {showPassword ? <FaEye /> : <FaEyeSlash />}
                  </div>
                </div>
              </div>
              <div className="mt-5 mb-5">
                <label
                  htmlFor="password"
                  className="self-start text-neutral-500"
                >
                  {langData?.['confirm_password']}
                </label>
                <div className="flex gap-5 justify-between px-3.5 py-3 mt-3 bg-white rounded-lg border border-solid border-neutral-200 placeholder:text-neutral-500 text-opacity-60">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    id="password"
                    className="w-full bg-transparent border-none focus:outline-none"
                    placeholder={langData?.['confirm_your_password']}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                  <div
                    className="cursor-pointer text-neutral-500"
                    onClick={() => showConfirmPasswordClickHandler()}
                  >
                    {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
                  </div>
                </div>
              </div>
              {otpTimer !== undefined && otpTimer !== null && otpTimer >= 0 ? (
                <Button
                  className="w-full my-1 bg-neutral-400 text-white py-2 rounded-md cursor-not-allowed"
                  disabled
                >
                  {`Resend in ${otpTimer} sec`}
                </Button>
              ) : showOtpButtons ? (
                <div className="flex gap-2 my-1">
                  {(showSmsOtpButton || showGenericOtpButton) && (
                    <Button
                      className={`flex-1 bg-blue-500 hover:bg-blue-600 text-white py-2 rounded-md ${!showWhatsappOtpButton ? "w-full" : ""}`}
                      onClick={() => handlesendotp(false)}
                    >
                      {showGenericOtpButton
                        ? langData?.["send_otp"] ?? "Send OTP"
                        : langData?.["resend_sms_otp"] ?? "Resend SMS OTP"}
                    </Button>
                  )}
                  {showWhatsappOtpButton && (
                    <Button
                      className={`flex-1 bg-teal-600 hover:bg-teal-700 text-white py-2 rounded-md ${!showSmsOtpButton && !showGenericOtpButton ? "w-full" : ""}`}
                      onClick={() => handlesendotp(true)}
                    >
                      {langData?.["resend_whatsapp_otp"] ?? "Resend WhatsApp OTP"}
                    </Button>
                  )}
                </div>
              ) : null}
              <Button
                className="w-full bg-blue-800 text-white py-2 rounded-md hover:bg-blue-700 focus:outline-none focus:bg-blue-800"
                onClick={handleResetPassword}
              >
                {langData?.['reset_password_txt']}
              </Button>
            </>
          )}
          <p className="self-center mt-4 text-sm text-center text-white">
          {langData?.['account_not_found_txt']}{" "}
            <a
              href="#"
              className="font-semibold text-yellow-400 underline"
              onClick={() => redirectToSignUp()}
            >
              {langData?.['sign_up']}
            </a>
          </p>
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state: RootState) => {
  return {
    otpSuccess: state.auth.otpSuccess,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    showToast: (event: any) => dispatch(showToast(event)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
